import React from 'react';
import { bool } from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl, intlShape } from '../../util/reactIntl';
import { isScrollingDisabled } from '../../ducks/ui.duck';
import {
  Page,
  LayoutSingleColumn,
  ExternalLink,
} from '../../components';

import TopbarContainer from '../../containers/TopbarContainer/TopbarContainer';
import FooterContainer from '../../containers/FooterContainer/FooterContainer';

import css from './HelpPage.module.css';

export const HelpPageComponent = props => {
  const { scrollingDisabled, intl } = props;

  const title = intl.formatMessage({ id: 'HelpPage.title' });
  const schemaTitle = intl.formatMessage({ id: 'HelpPage.schemaTitle' }, { siteTitle: 'Gearify' });

  return (
    <Page title={schemaTitle} scrollingDisabled={scrollingDisabled}>
      <LayoutSingleColumn
        mainColumnClassName={css.mainWrapper}
        topbar={<TopbarContainer />}
        footer={<FooterContainer />}
      >
        <div className={css.content}>
            <h1 className={css.title}>
              <FormattedMessage id="HelpPage.title" />
            </h1>

            <div className={css.section}>
              <h2 className={css.sectionTitle}>
                <FormattedMessage id="HelpPage.contactSupportTitle" />
              </h2>
              <p className={css.description}>
                <FormattedMessage id="HelpPage.contactSupportDescription" />
              </p>
              <div className={css.contactInfo}>
                <div className={css.contactItem}>
                  <strong><FormattedMessage id="HelpPage.emailLabel" />:</strong>{' '}
                  <ExternalLink href="mailto:support@gearify.ai" className={css.link}>
                    support@gearify.ai
                  </ExternalLink>
                </div>
                <div className={css.contactItem}>
                  <strong><FormattedMessage id="HelpPage.phoneLabel" />:</strong>{' '}
                  <span className={css.phonePlaceholder}>
                    <FormattedMessage id="HelpPage.phoneComingSoon" />
                  </span>
                </div>
              </div>
            </div>

            <div className={css.section}>
              <h2 className={css.sectionTitle}>
                <FormattedMessage id="HelpPage.privacyTitle" />
              </h2>
              <p className={css.description}>
                <FormattedMessage id="HelpPage.privacyDescription" />
              </p>
              <div className={css.contactInfo}>
                <div className={css.contactItem}>
                  <strong><FormattedMessage id="HelpPage.emailLabel" />:</strong>{' '}
                  <ExternalLink href="mailto:privacy@gearify.ai" className={css.link}>
                    privacy@gearify.ai
                  </ExternalLink>
                </div>
              </div>
            </div>

            <div className={css.section}>
              <h2 className={css.sectionTitle}>
                <FormattedMessage id="HelpPage.legalTitle" />
              </h2>
              <p className={css.description}>
                <FormattedMessage id="HelpPage.legalDescription" />
              </p>
              <div className={css.contactInfo}>
                <div className={css.contactItem}>
                  <strong><FormattedMessage id="HelpPage.emailLabel" />:</strong>{' '}
                  <ExternalLink href="mailto:legal@gearify.ai" className={css.link}>
                    legal@gearify.ai
                  </ExternalLink>
                </div>
              </div>
            </div>

            <div className={css.section}>
              <h2 className={css.sectionTitle}>
                <FormattedMessage id="HelpPage.claimsTitle" />
              </h2>
              <p className={css.description}>
                <FormattedMessage id="HelpPage.claimsDescription" />
              </p>
              <div className={css.contactInfo}>
                <div className={css.contactItem}>
                  <strong><FormattedMessage id="HelpPage.emailLabel" />:</strong>{' '}
                  <ExternalLink href="mailto:claims@gearify.ai" className={css.link}>
                    claims@gearify.ai
                  </ExternalLink>
                </div>
              </div>
            </div>

            <div className={css.section}>
              <h2 className={css.sectionTitle}>
                <FormattedMessage id="HelpPage.faqTitle" />
              </h2>
              
              <div className={css.faqItem}>
                <h3 className={css.faqQuestion}>
                  <FormattedMessage id="HelpPage.faqDepositQuestion" />
                </h3>
                <p className={css.faqAnswer}>
                  <FormattedMessage id="HelpPage.faqDepositAnswer" />
                </p>
              </div>

              <div className={css.faqItem}>
                <h3 className={css.faqQuestion}>
                  <FormattedMessage id="HelpPage.faqPickupQuestion" />
                </h3>
                <p className={css.faqAnswer}>
                  <FormattedMessage id="HelpPage.faqPickupAnswer" />
                </p>
              </div>

              <div className={css.faqItem}>
                <h3 className={css.faqQuestion}>
                  <FormattedMessage id="HelpPage.faqCancellationQuestion" />
                </h3>
                <p className={css.faqAnswer}>
                  <FormattedMessage id="HelpPage.faqCancellationAnswer" />
                </p>
              </div>
            </div>
          </div>
      </LayoutSingleColumn>
    </Page>
  );
};

HelpPageComponent.defaultProps = {
  scrollingDisabled: false,
};

HelpPageComponent.propTypes = {
  scrollingDisabled: bool,
  intl: intlShape.isRequired,
};

const mapStateToProps = state => {
  return {
    scrollingDisabled: isScrollingDisabled(state),
  };
};

const HelpPage = compose(
  connect(mapStateToProps),
  injectIntl
)(HelpPageComponent);

export default HelpPage;
